import Vue from "vue";
import VueRouter from "vue-router";
import { getUTMParamsFromQuery } from "@/app-js/helper";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    meta: { requiresAuth: false },
    component: () => import("@/components/layout/Base.vue"),
    children: [
      {
        path: "/",
        name: "home",
        meta: {
          requiresAuth: false,
          title: "Home",
          track_page: true,
          seo_title: "Personal & Business Loans | Loan against Securities",
          seo_description:
            "A leading instant loan service provider in raipur providing personal and small business loans at an attractive interest rates.",
        },
        component: () => import("@/views/HomeView.vue"),
      },
      {
        // Routed sign-in flow: /login -> /verify-otp -> /check-eligibility ->
        // offers. Each step is its own URL so GTM (router.afterEach) can track
        // drop-off. `hideChrome` hides the site NavBar/Footer for any
        // full-screen page -- this flow and the campaign landing page (see
        // Base.vue).
        path: "/login",
        name: "login",
        meta: {
          requiresAuth: false,
          title: "Login",
          track_page: true,
          hideChrome: true,
          seo_title: "Apply for Easy and Instant Personal Loans - Karrofin",
          seo_description:
            "We are the best personal loan provider company in India offering quick and instant personal loans at low interest rates.",
        },
        component: () => import("../views/auth/LoginPage.vue"),
      },
      {
        path: "/verify-otp",
        name: "verify-otp",
        meta: {
          requiresAuth: false,
          title: "Verify OTP",
          track_page: true,
          hideChrome: true,
          seo_title: "Apply for Easy and Instant Personal Loans - Karrofin",
          seo_description:
            "We are the best personal loan provider company in India offering quick and instant personal loans at low interest rates.",
        },
        component: () => import("../views/auth/VerifyOtpPage.vue"),
        beforeEnter: (to, from, next) => {
          // Nothing to verify without an otp-token (or at least the mobile).
          const ok =
            !!localStorage.getItem("otp-token") ||
            !!localStorage.getItem("login_mobile");
          next(ok ? undefined : { path: "/login" });
        },
      },
      {
        path: "/check-eligibility",
        name: "check-eligibility",
        meta: {
          requiresAuth: false,
          title: "Check Eligibility",
          track_page: true,
          hideChrome: true,
          seo_title: "Apply for Easy and Instant Personal Loans - Karrofin",
          seo_description:
            "We are the best personal loan provider company in India offering quick and instant personal loans at low interest rates.",
        },
        component: () => import("../views/auth/CheckEligibilityPage.vue"),
        beforeEnter: (to, from, next) => {
          // Eligibility requires an authenticated session.
          const ok = !!(localStorage.getItem("token") || "").trim();
          next(ok ? undefined : { path: "/login" });
        },
      },
      {
        path: "/status",
        name: "status",
        meta: {
          requiresAuth: false,
          title: "Status",
          track_page: false,
          seo_title: "Status",
          seo_description: "",
        },
        component: () => import("../views/Status.vue"),
      },
      {
        path: "/bank-details",
        name: "bank-details",
        meta: {
          requiresAuth: false,
          title: "Bank Details",
          track_page: false,
          seo_title: "Bank Details",
          seo_description: "",
        },
        component: () => import("../views/BankDetails.vue"),
      },
      {
        path: "/application-form",
        name: "application-form",
        meta: {
          requiresAuth: false,
          title: "Status",
          track_page: false,
          seo_title: "Status",
          seo_description: "",
        },
        component: () => import("../views/ApplicationForm.vue"),
      },
      {
        path: "/responsible-lending.html",
        name: "responsible-lending",
        meta: {
          requiresAuth: false,
          title: "Responsible Lending",
          track_page: true,
          seo_title: "Responsible Lending",
          seo_description: "",
        },
        component: () => import("../views/ResponsibleLending.vue"),
      },
      {
        path: "/about-us.html",
        name: "about-us",
        meta: {
          requiresAuth: false,
          title: "About Us",
          track_page: false,
          seo_title: "Msme & Personal Loans | Loan against Mutual Funds",
          seo_description:
            "Get msme and personal loans at an attractive interest rates from one of the quick loan service provider raipur.",
        },
        component: () => import("../views/AboutView.vue"),
      },
      {
        path: "/team.html",
        name: "team",
        meta: {
          requiresAuth: false,
          title: "Team",
          track_page: true,
          seo_title: "Team",
          seo_description: "",
        },
        component: () => import("../views/TeamView.vue"),
      },
      {
        path: "/contact.html",
        name: "contact",
        meta: {
          requiresAuth: false,
          title: "Contact",
          track_page: false,
          seo_title: "Contact Us",
          seo_description: "",
        },
        component: () => import("../views/ContactView.vue"),
      },
      {
        // A campaign link, generated in the admin panel and shared by hand.
        // Public by design -- there is no session behind it. `:token` is signed
        // server-side, so it names one campaign and cannot be edited into
        // another; the page hands it straight back to the API.
        path: "/campaign/:token",
        name: "campaign-products",
        meta: {
          requiresAuth: false,
          title: "Offers",
          track_page: true,
          // Someone arriving from a WhatsApp blast gets the brand, the
          // campaign's products and nothing to navigate to: no NavBar, no
          // Footer. The page renders its own KarroFin logo instead.
          hideChrome: true,
          seo_title: "Offers",
          seo_description: "",
        },
        component: () => import("../views/CampaignProductsView.vue"),
      },
      {
        path: "/products/:type",
        name: "products",
        meta: {
          requiresAuth: false,
          title: "Products",
          track_page: true,
          seo_title: "Products",
          seo_description: "",
        },
        component: () => import("../views/ProductsView.vue"),
      },
      {
        path: "/blogs",
        name: "blogs",
        meta: {
          requiresAuth: false,
          title: "Blogs",
          track_page: true,
          seo_title: "Blogs",
          seo_description: "",
        },
        component: () => import("../views/BlogsView.vue"),
      },
      {
        path: "/career.html",
        name: "career",
        meta: {
          requiresAuth: false,
          title: "Career",
          track_page: true,
          seo_title: "Career",
          seo_description: "",
        },
        component: () => import("../views/Career.vue"),
      },
      {
        path: "/legal.html",
        name: "legal",
        meta: {
          requiresAuth: false,
          title: "Legal",
          track_page: true,
          seo_title: "Legal",
          seo_description: "",
        },
        component: () => import("../views/LegalView.vue"),
      },
      {
        path: "/Terms&Condition.html",
        name: "TermsAndConditions",
        meta: {
          requiresAuth: false,
          title: "Terms and Conditions",
          track_page: true,
          seo_title: "Terms and Conditions",
          seo_description: "",
        },
        component: () => import("../views/TermsAndConditions.vue"),
      },
      {
        path: "/Privacy-policy.html",
        name: "Privacy-policy",
        meta: {
          requiresAuth: false,
          title: "Privacy Policy",
          track_page: true,
          seo_title: "Privacy Policy",
          seo_description: "",
        },
        component: () => import("../views/PrivacyPolicy.vue"),
      },
      // remove once the app link are fixed (duplicate paths without .html)
      // -------------------------
      {
        path: "/legal",
        name: "legal-no-html",
        meta: {
          requiresAuth: false,
          title: "Legal",
          track_page: true,
          seo_title: "Legal",
          seo_description: "",
        },
        component: () => import("../views/LegalView.vue"),
      },
      {
        path: "/Terms&Condition",
        name: "TermsAndConditions-no-html",
        meta: {
          requiresAuth: false,
          title: "Terms and Conditions",
          track_page: true,
          seo_title: "Terms and Conditions",
          seo_description: "",
        },
        component: () => import("../views/TermsAndConditions.vue"),
      },
      {
        path: "/Privacy-policy",
        name: "Privacy-policy-no-html",
        meta: {
          requiresAuth: false,
          title: "Privacy Policy",
          track_page: true,
          seo_title: "Privacy Policy",
          seo_description: "",
        },
        component: () => import("../views/PrivacyPolicy.vue"),
      },
      // --------------------------
      {
        path: "/Instant-loan.html",
        name: "Instant-loan",
        meta: {
          requiresAuth: false,
          title: "Instant Loan",
          track_page: true,
          seo_title: "Instant Loan",
          seo_description: "",
        },
        component: () => import("../views/InstantLoan.vue"),
      },
      {
        path: "/submittion-page",
        name: "submittion-page",
        meta: {
          requiresAuth: false,
          title: "Submittion Page",
          track_page: true,
          seo_title: "Submittion Page",
          seo_description: "",
        },
        component: () => import("../views/SubmittionMessage.vue"),
      },
      {
        path: "/user_already_exists",
        name: "user_exists_message",
        meta: {
          requiresAuth: false,
          title: "User Exists Message",
          track_page: true,
          seo_title: "User Exists Message",
          seo_description: "",
        },
        component: () => import("../views/UserAlreadyExistsPage.vue"),
      },
      {
        path: "/FAQ.html",
        name: "FAQ",
        meta: {
          requiresAuth: false,
          title: "FAQ",
          track_page: true,
          seo_title: "FAQ",
          seo_description: "",
        },
        component: () => import("../views/FaqsView.vue"),
      },
      {
        path: "/upload_bank_statement.html",
        name: "upload-bank-statement",
        meta: {
          requiresAuth: false,
          title: "Upload Bank Statement",
          track_page: true,
          seo_title: "Upload Bank Statement",
          seo_description: "",
        },
        component: () => import("../views/UploadBankStatement.vue"),
      },
      {
        path: "/business-loan-login",
        name: "business-loan-login",
        meta: {
          requiresAuth: false,
          title: "Business Loan Login",
          track_page: true,
          seo_title: "Apply for Quick Business and MSME Loans with Karrofin",
          seo_description:
            "Apply for business loan from Karrofin a leading and an instant loan service provider company in raipur.",
        },
        component: () => import("../views/BusinessLoanLoginPage.vue"),
        // component: () => import("../views/BusinessLoanRegisterPage.vue"),
      },
      {
        path: "/business-loan-register/:lead_source?",
        name: "business-loan-register",
        meta: {
          requiresAuth: false,
          title: "Business Loan Register",
          track_page: true,
          seo_title: "Apply for Quick Business and MSME Loans with Karrofin",
          seo_description:
            "Apply for business loan from Karrofin a leading and an instant loan service provider company in raipur.",
        },
        component: () => import("../views/BusinessLoanRegisterPage.vue"),
      },
      {
        path: "/business-loan",
        name: "Business-Loan",
        meta: {
          requiresAuth: true,
          title: "Business Loan",
          track_page: true,
          seo_title: "Apply for Quick Business and MSME Loans with Karrofin",
          seo_description:
            "Apply for business loan from Karrofin a leading and an instant loan service provider company in raipur.",
        },
        component: () => import("../views/BusinessLoanView.vue"),
      },
      {
        path: "/offers-list",
        name: "offers-list",
        meta: {
          requiresAuth: false,
          title: "Offers",
          track_page: true,
          seo_title: "",
          seo_description: "",
        },
        component: () => import("../components/business_loan/OffersList.vue"),
      },
      {
        path: "/business-loan-info",
        name: "Business-Loan-Info",
        meta: {
          requiresAuth: false,
          title: "Business Loan Info",
          track_page: true,
          seo_title: "Apply for Quick Business and MSME Loans with Karrofin",
          seo_description:
            "Apply for business loan from Karrofin a leading and an instant loan service provider company in raipur.",
        },
        component: () => import("../views/BusinessLoanIntro.vue"),
      },
      // {
      //   path: "/business-loan",
      //   name: "Business-Loan",
      //   meta: { requiresAuth: true, title: "", track_page: false },
      //   component: () => import("../views/BusinessLoanView.vue"),
      // },
      {
        path: "/mutual-funds-register",
        name: "mutual-funds-register",
        meta: {
          requiresAuth: false,
          title: "LAS Register",
          track_page: true,
          seo_title: "Get Loan against Mutual Funds & Securities with KarroFin",
          seo_description:
            "We offer instant loan against mutual funds and securities facility at an attractive interest rates in Karrofin.",
        },
        component: () => import("../views/mutualFundsRegisterPage.vue"),
      },
      {
        path: "/mutual-funds-login",
        name: "mutual-funds-login",
        meta: {
          requiresAuth: false,
          title: "LAS Login",
          track_page: true,
          seo_title: "Get Loan against Mutual Funds & Securities with KarroFin",
          seo_description:
            "We offer instant loan against mutual funds and securities facility at an attractive interest rates in Karrofin.",
        },
        component: () => import("../views/mutualFundsLogin.vue"),
      },
      {
        path: "/our-lending-partners",
        name: "our-lending-partners",
        meta: {
          requiresAuth: false,
          title: "Our Lending Partners",
          track_page: true,
          seo_title: "Our Lending Partners",
          seo_description: "",
        },
        component: () => import("../views/OurLendingPartners.vue"),
      },
      {
        path: "/become-a-partner",
        name: "become-a-partner",
        meta: {
          requiresAuth: false,
          title: "Become a Partner",
          track_page: true,
          seo_title: "Become a Partner",
          seo_description: "",
        },
        component: () => import("../views/BecomePartner.vue"),
      },
      {
        path: "/gro-details",
        name: "gro-details",
        meta: {
          requiresAuth: false,
          title: "Grievance Redressal Officer Details",
          track_page: true,
          seo_title: "Grievance Redressal Officer Details",
          seo_description: "",
        },
        component: () => import("../views/GrievanceRedressalOfficer.vue"),
      },
      {
        path: "/data-storage-policy",
        name: "data-storage-policy",
        meta: {
          requiresAuth: false,
          title: "Data Storage Policy",
          track_page: true,
          seo_title: "Data Storage Policy",
          seo_description: "",
        },
        component: () => import("../views/DataStoragePolicy.vue"),
      },
      {
        path: "/business-loan-details",
        name: "business-loan-details",
        meta: {
          requiresAuth: false,
          title: "Busniess Loan Page",
          track_page: true,
          seo_title: "Apply for Quick Business and MSME Loans with Karrofin",
          seo_description:
            "Apply for business loan from Karrofin a leading and an instant loan service provider company in raipur.",
        },
        component: () => import("../views/BusinessLoanDetails.vue"),
      },
      {
        path: "/personal-loan-details",
        name: "personal-loan-details",
        meta: {
          requiresAuth: false,
          title: "Personal Loan Page",
          track_page: true,
          seo_title: "Apply for Easy and Instant Personal Loans - Karrofin",
          seo_description:
            "We are the best personal loan provider company in India offering quick and instant personal loans at low interest rates.",
        },
        component: () => import("../views/PersonalLoanDetails.vue"),
      },
      {
        path: "/personal-loan",
        name: "personal-loan",
        meta: {
          requiresAuth: false,
          seo_title: "Apply for Easy and Quick Personal Loans with Karrofin",
          seo_description:
            "Apply for personal loan from Karrofin a leading and an instant loan service provider company in raipur.",
        },
        component: () => import("../views/personal-loan/index.vue"),
        children: [
          {
            path: "register",
            name: "personal-loan-register",
            meta: {
              requiresAuth: false,
              title: "Personal Loan",
              track_page: true,
              seo_title: "Apply for Easy and Quick Personal Loans with Karrofin",
              seo_description:
                "Apply for personal loan from Karrofin a leading and an instant loan service provider company in raipur.",
            },
            component: () =>
              import(/* webpackChunkName: "personal-loan", webpackPrefetch: true */ "../views/personal-loan/PersonalLoanRegister.vue"),
            beforeEnter: (to, from, next) => {
              const utm_medium = to.query.utm_medium || null;
              const campaign_name = to.query.campaign_name || null;
              sessionStorage.setItem("campaign_name", campaign_name);
              sessionStorage.setItem("utm_medium", utm_medium);
              next();
            },
          },
          {
            path: "otp",
            name: "personal-loan-otp",
            meta: {
              requiresAuth: false,
              title: "Personal Loan",
              track_page: true,
              seo_title: "Apply for Easy and Quick Personal Loans with Karrofin",
              seo_description:
                "Apply for personal loan from Karrofin a leading and an instant loan service provider company in raipur.",
            },
            component: () => import("../views/personal-loan/OtpView.vue"),
          },
          {
            path: "otp",
            name: "otp",
            meta: {
              requiresAuth: false,
              title: "Otp-Verify",
              track_page: true,
              seo_title: "Apply for Easy and Quick Personal Loans with Karrofin",
              seo_description:
                "Apply for personal loan from Karrofin a leading and an instant loan service provider company in raipur.",
            },
            component: () => import("../views/personal-loan/OtpView.vue"),
          },
          {
            path: "eligible-offers",
            name: "personal-loan-eligible-offers",
            meta: {
              requiresAuth: false,
              title: "Personal Loan",
              track_page: true,
              seo_title: "Apply for Easy and Quick Personal Loans with Karrofin",
              seo_description:
                "Apply for personal loan from Karrofin a leading and an instant loan service provider company in raipur.",
            },
            component: () =>
              import("../views/personal-loan/EligibleOffersList.vue"),
          },
          {
            path: "login",
            name: "personal-loan-login",
            meta: {
              requiresAuth: false,
              title: "Personal Loan",
              track_page: true,
              seo_title: "Apply for Easy and Quick Personal Loans with Karrofin",
              seo_description:
                "Apply for personal loan from Karrofin a leading and an instant loan service provider company in raipur.",
            },
            component: () => import("../views/PersonalLoanLogin.vue"),
          },
        ],
      },
      {
        path: "/dlg-disclosure",
        name: "dlg-disclosure",
        meta: {
          requiresAuth: false,
          title: "DLG Disclosure",
          track_page: true,
          seo_title: "DLG Disclosure",
          seo_description: "",
        },
        component: () => import("../views/DlgDisclosure.vue"),
      },
      {
        path: "/home",
        name: "home-seo",
        meta: {
          requiresAuth: false,
          title: "Home",
          track_page: true,
          seo_title: "Personal & Business Loans | Loan against Securities",
          seo_description:
            "A leading instant loan service provider in raipur providing personal and small business loans at an attractive interest rates.",
        },
        component: () => import("@/views/HomeView.vue"),
      },
      {
        path: "/about-us-seo",
        name: "about-us-seo",
        meta: {
          requiresAuth: false,
          title: "About Us",
          track_page: true,
          seo_title: "Msme & Personal Loans | Loan against Mutual Funds",
          seo_description:
            "Get msme and personal loans at an attractive interest rates from one of the quick loan service provider raipur.",
        },
        component: () => import("../views/AboutView.vue"),
      },
      {
        path: "/personal-loan-seo",
        name: "personal-loan-seo",
        meta: {
          requiresAuth: false,
          title: "Personal Loan Page",
          track_page: true,
          seo_title: "Apply for Easy and Quick Personal Loans with Karrofin",
          seo_description:
            "Apply for personal loan from Karrofin a leading and an instant loan service provider company in raipur.",
        },
        component: () => import(/* webpackChunkName: "personal-loan", webpackPrefetch: true */ "../views/personal-loan/PersonalLoanRegister.vue"),
      },
      {
        path: "/business-loan-seo",
        name: "business-loan-seo",
        meta: {
          requiresAuth: false,
          title: "Busniess Loan Page",
          track_page: true,
          seo_title: "Apply for Quick Business and MSME Loans with Karrofin",
          seo_description:
            "Apply for business loan from Karrofin a leading and an instant loan service provider company in raipur.",
        },
        component: () => import("../views/BusinessLoanRegisterPage.vue"),
      },
      {
        path: "/mutual-funds-seo",
        name: "mutual-funds-seo",
        meta: {
          requiresAuth: false,
          title: "LAS Login",
          track_page: true,
          seo_title: "Get Loan against Mutual Funds & Securities with Karrofin",
          seo_description:
            "We offer instant loan against mutual funds and securities facility at an attractive interest rates in Karrofin.",
        },
        component: () => import("../views/mutualFundsRegisterPage.vue"),
      },
      {
        path: "/delete-account",
        name: "delete-account",
        meta: {
          requiresAuth: false,
          title: "Delete Account",
          track_page: true,
          seo_title: "",
          seo_description: "",
        },
        component: () => import("../views/delete-account/DeleteAccount.vue"),
      },
    ],
  },
  {
    path: "/borrower_consent",
    name: "Borrower Consent",
    meta: {
      requiresAuth: false,
      title: "Borrower Consent",
      track_page: true,
      seo_title: "Borrower Consent",
      seo_description: "",
    },
    component: () => import("../views/BorrowersConsentView.vue"),
  },
  {
    path: "/third_party_consent",
    name: "Third Party Consent",
    meta: {
      requiresAuth: false,
      title: "Third Party Consent",
      track_page: true,
      seo_title: "Third Party Consent",
      seo_description: "",
    },
    component: () => import("../views/ThirdPartyConsentView.vue"),
  },
  {
    path: "/karrofin_grievance_policy",
    name: "Karrofin Grievance Policy",
    meta: {
      requiresAuth: false,
      title: "Karrofin Grievance Policy",
      track_page: true,
      seo_title: "Karrofin Grievance Policy",
      seo_description: "",
    },
    component: () => import("../views/GrievancePolicy.vue"),
  },
  {
    path: "/privacy_policies",
    name: "Privacy Policies",
    meta: {
      requiresAuth: false,
      title: "Privacy Policies",
      track_page: true,
      seo_title: "Privacy Policies",
      seo_description: "",
    },
    component: () => import("../views/PrivacyPolicyView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  // Capture UTM attribution on any entry page (e.g. /login, home, landing pages),
  // mirroring the register pages. Only write when the incoming URL carries a UTM
  // param so plain navigations never overwrite a prior capture with empties.
  // CheckEligibilityPage later reads localStorage["utm_data"] and sends it upstream.
  try {
    const utmParams = getUTMParamsFromQuery(to.query);
    if (Object.values(utmParams).some((v) => v)) {
      localStorage.setItem("utm_data", JSON.stringify(utmParams));
    }
  } catch (e) {
    // ignore storage errors
  }
  next();
});

// router.beforeEach((to, from, next) => {
//   let access_token = sessionStorage.getItem("token");
//   if (to.meta.requiresAuth == true && !access_token) {
//     next({
//       name: "login",
//     });
//   } else next();
// });
router.beforeEach((to, from, next) => {
  // let access_token = sessionStorage.getItem("token");
  if (to.fullPath == "/personal-loan-register") {
    next({
      name: "personal-loan-register",
    });
  }
  let business_loan_token = sessionStorage.getItem("access_token");
  if (to.meta.requiresAuth == true && !business_loan_token) {
    next({
      name: "business-loan-login",
    });
  } else next();
});

//to track every page with track_page=true
router.afterEach((to) => {
  window.dataLayer = window.dataLayer || [];

  if (to.meta.track_page) {
    window.dataLayer.push({
      event: "pageview",
      page_path: to.fullPath,
      page_name: to.name,
      page_title: to.meta.seo_title || document.title,
    });
  }
});

export default router;
